export default __webpack_public_path__ + "locales/fr/Common.json?hash=98ddeb43e22220cb0a25346e8114d2bf";